export const FORM_VALIDITY = {
  VALID: 'VALID',
  NOT_VALID: 'NOT_VALID',
  NOT_CHANGED: 'NOT_CHANGED',
}

Object.freeze(FORM_VALIDITY)

interface Field {
  value: any
  required: boolean
  validation?: string
  pattern?: RegExp
}

interface FormData {
  [key: string]: Field
}

export class Form {
  fields: FormData

  constructor(formData: FormData) {
    Object.values(formData).map((field: Field) => {
      if (!field.required) {
        // eslint-disable-next-line no-param-reassign
        field.validation = FORM_VALIDITY.VALID
      } else {
        // eslint-disable-next-line no-param-reassign
        field.validation = FORM_VALIDITY.NOT_CHANGED
        if (field.value) {
          // eslint-disable-next-line no-param-reassign
          field.validation = FORM_VALIDITY.VALID
        }
      }
    })
    this.fields = formData
  }

  isValid() {
    return Object.values(this.fields).every((requiredField: Field) => requiredField.validation === FORM_VALIDITY.VALID)
  }

  isFieldValid(fieldName) {
    return this.fields[fieldName].validation !== FORM_VALIDITY.NOT_VALID
  }

  verifyField(field) {
    // eslint-disable-next-line no-param-reassign
    field.validation = !((field.value === null || field.value === '' || field.value === false) && field.required)
      ? FORM_VALIDITY.VALID
      : FORM_VALIDITY.NOT_VALID
    if (field.pattern && field.value) {
      const pattern = new RegExp(field.pattern)
      // eslint-disable-next-line no-param-reassign
      field.validation = pattern.test(String(field.value)) ? FORM_VALIDITY.VALID : FORM_VALIDITY.NOT_VALID
    }
  }
}
